(function () {
  const BlendQuiz = window.BlendQuiz = window.BlendQuiz || {};

  // ── Quiz loader overlay (icons + text) ───────────────────────
  BlendQuiz.showQuizLoader = function () {
    const el = document.getElementById('quiz-loading-overlay');
    if (!el) return;
    el.classList.remove('is-error');
    el.style.display = 'flex';
    requestAnimationFrame(() => el.classList.add('active'));
    _startIconCycle();
  };

  BlendQuiz.hideQuizLoader = function () {
    _stopIconCycle();
    const el = document.getElementById('quiz-loading-overlay');
    if (!el) return;
    el.classList.remove('active');
    setTimeout(() => { el.style.display = 'none'; el.classList.remove('is-error'); }, 400);
  };

  // Turn the open loader into the retry dialog (#quiz-submit-error) instead of closing it.
  BlendQuiz.showQuizLoaderError = function (message) {
    _stopIconCycle();
    const el = document.getElementById('quiz-loading-overlay');
    const text = document.getElementById('quiz-submit-error-text');
    if (!el || !text) return;
    text.textContent = message;
    el.classList.add('is-error');
    document.getElementById('quiz-submit-retry')?.focus();
  };

  BlendQuiz.isQuizLoaderError = function () {
    const el = document.getElementById('quiz-loading-overlay');
    return Boolean(el && el.classList.contains('active') && el.classList.contains('is-error'));
  };

  // Update just the loading message (used to signal "Your blend is ready!")
  BlendQuiz.setLoaderMessage = function (text) {
    if (!_msg) return;
    _msg.style.opacity = '0';
    setTimeout(() => {
      if (_msg) { _msg.textContent = text; _msg.style.opacity = '1'; }
    }, 350);
  };

  // ── Icon crossfade state ──────────────────────────────────────
  let _iconKeys = [], _idx = 0, _isA = true;
  let _iconA, _iconB, _msg;
  let _map = {}, _phrases = [], _fallback = 'Finalizing recipe…';
  let _fade = 1000, _hold = 2200;
  let _cycleTimer = null, _cycleActive = false;

  // Register config only — cycle starts when showQuizLoader is called.
  BlendQuiz.initIconLoader = function ({ map, keys, msgEl, aEl, bEl, texts, fallbackText, fadeMs, holdMs }) {
    _map = map || {};
    _iconKeys = keys || Object.keys(map || {});
    _iconA = aEl; _iconB = bEl; _msg = msgEl;
    _phrases = Array.isArray(texts) ? texts : [];
    _fallback = fallbackText || _fallback;
    _fade = typeof fadeMs === 'number' ? fadeMs : _fade;
    _hold = typeof holdMs === 'number' ? holdMs : _hold;
    // Fetch and decode every icon now, so a swap never waits on the network or the decoder.
    Object.values(_map).forEach((src) => {
      const img = new Image();
      img.src = src;
      img.decode?.().catch(() => {});
    });
  };

  function _stopIconCycle() {
    _cycleActive = false;
    if (_cycleTimer) { clearTimeout(_cycleTimer); _cycleTimer = null; }
  }

  function _startIconCycle() {
    _stopIconCycle();
    if (!_iconKeys.length || !_iconA || !_iconB) return;

    _cycleActive = true;
    _isA = true;
    _idx = 0;

    // Show first icon + phrase immediately (no fade-in delay on first frame); the hidden icon
    // already holds the next one, so the swap is a pure crossfade.
    _iconA.src = _map[_iconKeys[0]] || _iconA.src;
    _iconA.classList.add('visible');
    _iconB.classList.remove('visible');
    if (_iconKeys[1]) _iconB.src = _map[_iconKeys[1]];
    if (_msg) { _msg.textContent = _phrases[0] || _fallback; _msg.style.opacity = '1'; }

    _cycleTimer = setTimeout(_advanceIcon, _hold);
  }

  function _advanceIcon() {
    if (!_cycleActive) return;
    _idx++;

    if (_idx >= _iconKeys.length) {
      // All icons shown — settle on fallback message
      if (_msg) {
        _msg.style.opacity = '0';
        _cycleTimer = setTimeout(() => {
          if (!_cycleActive) return;
          _msg.textContent = _fallback;
          _msg.style.opacity = '1';
        }, _fade);
      }
      return;
    }

    const key = _iconKeys[_idx];
    const outgoing = _isA ? _iconA : _iconB;
    const incoming = _isA ? _iconB : _iconA;

    // Crossfade the icons (the incoming one was loaded while hidden) and fade the text out
    incoming.alt = key;
    outgoing.classList.remove('visible');
    incoming.classList.add('visible');
    if (_msg) _msg.style.opacity = '0';
    _isA = !_isA;

    _cycleTimer = setTimeout(() => {
      if (!_cycleActive) return;
      if (_msg) {
        _msg.textContent = _phrases[_idx] || _fallback;
        _msg.style.opacity = '1';
      }
      // Load the next icon into the one now hidden, well before it's shown
      const nextKey = _iconKeys[_idx + 1];
      if (nextKey) outgoing.src = _map[nextKey];
      _cycleTimer = setTimeout(_advanceIcon, _hold);
    }, _fade);
  }
})();
